/* eslint-disable react/display-name */
import { Popconfirm, Space } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Tag } from "antd";

import TableBase from "../../../../../components/table/TableBase";
import { allowPermission, convertHexToRGBA } from "../../../../../helper/util";
import { deleteUser } from "../../store/thunks";
import { selectRole } from "modules/auth/store/authSlice";
import { UserRole } from "configs/constants";

const AdminUserTerritoryTable = ({ dataSource, pagination }) => {
  const role = useSelector(selectRole);
  const canEdit = allowPermission(role, [UserRole.ADMIN]);
  const canDelete = allowPermission(role, [UserRole.ADMIN]);
  const history = useHistory();
  const dispatch = useDispatch();
  const handleDelete = (user) => {
    dispatch(deleteUser(user));
  };

  const handleEdit = (record) => {
    history.push(`/admin/users/territories/${record.id}`);
  };
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      width: 120,
      render: (value) => {
        return (
          <p style={{ margin: 0, color: "#1f3998" }}>
            {value.substr(0, 8).toUpperCase()}
          </p>
        );
      }
    },
    {
      title: "First Name",
      dataIndex: "firstName",
      width: 150
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      width: 150
    },
    {
      title: "Email",
      dataIndex: "email",
      ellipsis: true
    },
    // {
    //   title: "Company Name",
    //   dataIndex: "company",
    //   with: "130px"
    // },
    {
      title: "Role",
      dataIndex: "role",
      width: 150,
      render: (value) => {
        let text = "Super Admin";
        let color = "#43c1c2";
        switch (value) {
          case "manager":
            text = "Manager";
            color = "#f78B0f";
            break;
          case "viewer":
            text = "View Only";
            color = "#212121";
            break;
          default:
            break;
        }
        return (
          <Tag
            color={convertHexToRGBA(color, 20)}
            style={{
              color,
              lineHeight: "24px",
              width: "112px",
              textAlign: "center",
              fontWeight: "600"
            }}
          >
            {text}
          </Tag>
        );
      }
    },
    {
      title: "Phone Number",
      dataIndex: "phone",
      width: 170
    },
    {
      title: "Territory",
      dataIndex: ["territory", "name"],
      width: 130
    }
  ];
  if (canEdit || canDelete) {
    columns.push({
      title: "",
      key: "action",
      width: 100,
      fixed: "right",
      // eslint-disable-next-line react/display-name
      render: (value, record) => {
        return (
          <Space size="middle">
            {canEdit && (
              <img
                src="/icons/edit.svg"
                className={`table-status ${value}`}
                onClick={() => handleEdit(record)}
              />
            )}
            {canDelete && (
              <Popconfirm
                title="Are you sure to delete this?"
                onConfirm={() => handleDelete(record)}
                okText="Yes"
                cancelText="No"
              >
                <img src="/icons/delete.svg" className={`table-status ${value}`} />
              </Popconfirm>
            )}
          </Space>
        );
      }
    });
  }
  return (
    <div className="AdminClientTable">
      <TableBase
        columns={columns}
        data={dataSource}
        pagination={pagination}
        rowKey="id"
      />
    </div>
  );
};
export default AdminUserTerritoryTable;
